import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, Typography, Box
} from '@mui/material';
 // adjust the import path
import { toast } from 'react-toastify';
import { upload } from '../../../services/api/fytnServices';

export default function ValidateDataStep({ uploadedData,uploadedFile, onBack, onNext,setOpenFileUpload,setRefetch,userId }) {
  const [validatedRows, setValidatedRows] = useState([]);

  const validateData = (data) => {
    return data.map((row, index) => {
      const errors = {};
      Object.entries(row).forEach(([key, value]) => {
        if (!value || value.toString().trim() === '') {
          errors[key] = 'Required';
        }
      });
      return {
        ...row,
        _errors: errors,
        _isValid: Object.keys(errors).length === 0,
        _index: index + 1,
      };
    });
  };

  useEffect(() => {
    if (uploadedData?.length) {
      const validated = validateData(uploadedData);
      setValidatedRows(validated);
    }
  }, [uploadedData]);

  const isAllValid = validatedRows.every(row => row._isValid);

  const handleUpload = async () => {
  try {
    const response = await upload(uploadedFile, userId);
    const resData = response.data;

    if (
      resData.status === "success" &&
      resData.data.addedUsers > 0 &&
      resData.data.addedMappings === 0
    ) {
      toast.success(resData.message);
      setOpenFileUpload(false);
      setRefetch(true);
    } else if (
      resData.status === "success" &&
      resData.data.addedUsers === 0 &&
      resData.data.addedMappings === 0
    ) {
      toast.error("User already present.");
      setOpenFileUpload(false);
    } else {
      toast.success(resData.message); // handle mixed cases or just mapping added
      setOpenFileUpload(false);
      setRefetch(true);
    }
  } catch (error) {
    toast.error("Upload failed. Please try again.");
    console.error(error);
  }
};


  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Validate Uploaded Data
      </Typography>

      {validatedRows.length === 0 ? (
        <Typography>No data found. Please upload a valid file.</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                {Object.keys(validatedRows[0]).filter(key => !key.startsWith('_')).map((col, idx) => (
                  <TableCell key={idx}>{col}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {validatedRows.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row._index}</TableCell>
                  {Object.entries(row).filter(([key]) => !key.startsWith('_')).map(([key, value]) => (
                    <TableCell
                      key={key}
                      sx={{ color: row._errors[key] ? 'red' : 'inherit' }}
                    >
                      {value || '-'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button variant="outlined" onClick={onBack}>Back</Button>
        <Button
          variant="contained"
          onClick={handleUpload}
     
        >
          Upload
        </Button>
      </Box>
    </Box>
  );
}
